import { Container } from "react-grid-system";
import styled from "styled-components";
import theme from "themes/simple-theme";

const Content = styled(Container)`
  margin-top: ${theme.global.nudge * 1.3}rem;
`;

export default Content;



// WEBPACK FOOTER //
// ./src/components/common/Grid/Container.tsx